import React, { FC } from "react";
import PageHeading from "../Common/PageHeading/PageHeading";
import PageContent from "../Common/PageContent/PageContent";

export const Joinus: FC = () => {
  return (
    <section>
      <PageHeading titleText="Stay in the know and Join Kivu tech community" />
      <PageContent>
        <section />
      </PageContent>
    </section>
  );
};

export default Joinus;
